import React, { useState, useEffect } from 'react';
import * as Tabs from "@radix-ui/react-tabs";
import { backend_url } from "../App"

const ITEMS_PER_PAGE = 15;

const ExplorerIdeas = () => {
  const [exploreIdeas, setExploreIdeas] = useState([]);
  const [imagePage, setImagePage] = useState(0);
  const [videoPage, setVideoPage] = useState(0);

  useEffect(() => {
    const fetchExploreIdeas = async () => {
      try {
        const response = await fetch(`${backend_url}/api/exploreideas`); 
        const data = await response.json();
        setExploreIdeas(data);
      } catch (error) {
        console.error("Error fetching explore ideas:", error);
      }
    };

    fetchExploreIdeas();
  }, []);

  // Separate images and videos based on `tab` field
  const images = exploreIdeas.filter(item => item.tab === "Images").map(item => item.mediaUrl);
  const videos = exploreIdeas.filter(item => item.tab === "Videos").map(item => item.mediaUrl);

  const totalImagePages = Math.ceil(images.length / ITEMS_PER_PAGE);
  const totalVideoPages = Math.ceil(videos.length / ITEMS_PER_PAGE);

  const paginatedImages = images.slice(imagePage * ITEMS_PER_PAGE, (imagePage + 1) * ITEMS_PER_PAGE);
  const paginatedVideos = videos.slice(videoPage * ITEMS_PER_PAGE, (videoPage + 1) * ITEMS_PER_PAGE);

  return (
    <>
    <div className="flex flex-col items-center justify-center p-6">
      <h2 className="text-3xl font-bold text-gray-800 mb-6" style={{ fontFamily: "'Times New Roman', Serif" }}>Our Explorer</h2>

      <div className="w-full max-w-6xl bg-white shadow-lg rounded-lg p-6">
        <Tabs.Root defaultValue="image">
          <Tabs.List className="flex justify-center space-x-4 mb-6">
            <Tabs.Trigger
              value="image"
              className="px-4 py-2 text-gray-600 font-medium bg-gray-300 rounded-lg transition hover:bg-[#cecece] data-[state=active]:bg-[#bb82f7] data-[state=active]:text-white">
              Images
            </Tabs.Trigger>
            <Tabs.Trigger
              value="video"
              className="px-4 py-2 text-gray-600 font-medium bg-gray-300 rounded-lg transition hover:bg-[#cecece] data-[state=active]:bg-[#bb82f7] data-[state=active]:text-white">
              Videos
            </Tabs.Trigger>
          </Tabs.List>

          <Tabs.Content value="image">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
              {paginatedImages.map((src, index) => (
                <img crossOrigin="anonymous" 
                  key={index}
                  src={`${src}`}
                  alt={`Gallery ${index}`}
                  className="w-full h-48 object-cover rounded-lg shadow-md hover:scale-105 transition duration-300"
                />
              ))}
            </div>

            {/* Image Pagination */}
            <div className="flex justify-center mt-4 space-x-2">
              <button
                onClick={() => setImagePage((prev) => Math.max(prev - 1, 0))}
                className={`px-4 py-2 bg-gray-300 rounded-lg ${imagePage === 0 ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-400'}`}>
                Prev
              </button>

              {/* Page Numbers */}
              {Array.from({ length: totalImagePages }).map((_, i) => (
                <button
                  key={i}
                  onClick={() => setImagePage(i)}
                  className={`px-3 py-2 rounded-lg transition ${imagePage === i ? 'bg-purple-500 text-white' : 'bg-gray-200 hover:bg-gray-300'
                    }`}>
                  {i + 1}
                </button>
              ))}

              <button
                onClick={() => setImagePage((prev) => (prev + 1 < totalImagePages ? prev + 1 : prev))}
                className={`px-4 py-2 bg-gray-300 rounded-lg ${imagePage + 1 >= totalImagePages ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-400'}`}>
                Next
              </button>
            </div>
          </Tabs.Content>

          {/* Videos Grid */}
          <Tabs.Content value="video">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              {paginatedVideos.map((src, index) => (
                <video key={index} autoPlay muted loop className="object-cover w-full h-96 rounded-lg shadow-md hover:scale-105 transition duration-300">
                  <source src={`${src}`} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              ))}
            </div>

            {/* Video Pagination */}
            <div className="flex justify-center mt-4 space-x-2">
              <button
                onClick={() => setVideoPage((prev) => Math.max(prev - 1, 0))}
                className={`px-4 py-2 bg-gray-300 rounded-lg ${videoPage === 0 ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-400'}`}>
                Prev
              </button>

              {/* Page Numbers */}
              {Array.from({ length: totalVideoPages }).map((_, i) => (
                <button
                  key={i}
                  onClick={() => setVideoPage(i)}
                  className={`px-3 py-2 rounded-lg transition ${videoPage === i ? 'bg-purple-500 text-white' : 'bg-gray-200 hover:bg-gray-300'
                    }`}>
                  {i + 1}
                </button>
              ))}

              <button
                onClick={() => setVideoPage((prev) => (prev + 1 < totalVideoPages ? prev + 1 : prev))}
                className={`px-4 py-2 bg-gray-300 rounded-lg ${videoPage + 1 >= totalVideoPages ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-400'}`}>
                Next
              </button>
            </div>
          </Tabs.Content>
        </Tabs.Root>
      </div>
    </div >
    </>
  );
};

export default ExplorerIdeas;
